module.exports = __webpack_public_path__ + "static/media/dgl-ipad.972d693b.png";